import Image from 'next/image';
import Link from 'next/link';
import LandingPageContainer from './landing-page-container';
import { prefix } from '../../lib/auth';

const LandingPageHeader = () => {
    
    return (
        <LandingPageContainer>
            <div className='flex items-center justify-between py-[15px]'>
                <Image src='https://cdn.workpeg.com/pegs/home/assets/logo/secondary-dark.svg' alt='logo' width={141} height={30} className='h-[46px]' />
                <div className='flex items-center gap-[29px]'>
                    <Link href={`http://${prefix()}accounts.workpeg.com/login?peg=developers`} className='text-white-50 text-[16px]'>Login</Link>
                    <Link href={`http://${prefix()}accounts.workpeg.com/register?peg=developers`} className='py-[6px] px-[24px] text-white-50 text-[16px] border-[1px] border-[#50565D] hover:bg-[#ffffff] hover:text-grey-900 transition-all duration-300 rounded-[6px] hidden lg:block'>Sign up</Link>
                </div>
            </div>
        </LandingPageContainer>
    );
};

export default LandingPageHeader;